<template>
  <div class="hero is-fullheight has-background-color-background is-relative">
    <gmap-map :center="center"></gmap-map>
    <router-view/>
  </div>
</template>

<script>
import { CENTER_DEFAULT } from '@/configuration/configurationCarte';

export default {
  data() {
    return {
      center: CENTER_DEFAULT,
    };
  },
};
</script>
